import type { LengthUnit } from "../types";

export enum GlassShape {
  Square = "Square",
  Rectangular = "Rectangular",
  Circular = "Circular",
  Oval = "Oval",
  Wedge = "Wedge",
}

export const GLASS_SPECIFIC_GRAVITY = 2.5;

export const calculateWeight = (
  type: GlassShape,
  unit: LengthUnit,
  width: number,
  thickness: number,
  height?: number,
  thickness2?: number,
): number => {
  let area: number;
  if (type === GlassShape.Square || type === GlassShape.Circular) {
    height = width;
  }

  if (unit === "in") {
    width = width * 25.4;
    height = (height ?? 0) * 25.4;
    thickness = thickness * 25.4;
    if (thickness2 !== undefined) thickness2 = thickness2 * 25.4;
  }

  const cm_height = (height ?? 0) / 10;
  const cm_width = width / 10;
  let cm_thickness = thickness / 10;
  const cm_thickness2 = (thickness2 ?? 0) / 10;

  switch (type) {
    case GlassShape.Square:
    case GlassShape.Rectangular:
      area = cm_width * cm_height;
      break;
    case GlassShape.Circular:
    case GlassShape.Oval:
      area = Math.PI * (cm_width / 2) * (cm_height / 2);
      break;
    case GlassShape.Wedge:
      cm_thickness = (cm_thickness + cm_thickness2) / 2;
      area = cm_width * cm_height;
      break;
    default:
      area = 0;
  }

  const volume = area * cm_thickness;
  return volume * GLASS_SPECIFIC_GRAVITY;
};
